// 📁 Imports
import axios from "axios";
import {
  buttonSpinnerAdd,
  buttonSpinnerRemove,
} from "@/utils/button-spinner.js";

// 💾 Variables
const pagination = document.querySelector("[data-pagination]");
const paginationNavigation = document.querySelector(
  "[data-pagination-navigation]",
);
let currentPage;

// 📐 Functions
// Fetch next page data
const fetchNextPage = async (url, currentPage) => {
  try {
    const response = await axios.get(url, {
      params: { pozice: currentPage },
    });
    const parser = new DOMParser();
    return parser.parseFromString(response.data, "text/html");
  } catch (error) {
    console.error("Chyba pri načítaní článkov:", error);
    return null;
  }
};

const updateUrlPath = (page) => {
  let currentPath = window.location.pathname;
  let newPath = currentPath.replace(/\/page-1-\d+/, "");
  newPath += `/page-1-${page}`;

  window.history.pushState({}, "", newPath);
};

const updatePaginationNav = (paginationNav, newData) => {
  paginationNav.innerHTML = newData.innerHTML;
};

const renderData = (content, newArticles) => {
  content.insertAdjacentHTML("beforeend", newArticles.innerHTML);
};

// 🖱️ Event listener
if (pagination) {
  const loadMoreButton = pagination.querySelector("[data-button-fetch]");
  const content = document.querySelector("[data-article-render]");
  const paginationUrl = pagination.dataset.paginationUrl;
  const paginationMaxPages = pagination.dataset.paginationPagesTotal;
  currentPage = pagination.dataset.paginationCurrentPage;

  if (content && loadMoreButton) {
    loadMoreButton.addEventListener("click", async () => {
      currentPage++;
      buttonSpinnerAdd(loadMoreButton);
      const doc = await fetchNextPage(paginationUrl, currentPage);
      setTimeout(() => {
        if (doc) {
          const newArticles = doc.querySelector("[data-article-render]");
          if (newArticles) {
            renderData(content, newArticles);
            updateUrlPath(currentPage);
            buttonSpinnerRemove(loadMoreButton);
          }

          if (paginationNavigation) {
            const newPaginationNav = doc.querySelector(
              "[data-pagination-navigation]",
            );
            updatePaginationNav(paginationNavigation, newPaginationNav);
          }
        } else {
          currentPage = pagination.dataset.paginationCurrentPage;
        }

        if (Number(paginationMaxPages) <= currentPage) {
          setTimeout(() => {
            loadMoreButton.remove();
          });
        }
      }, 500);
    });
  }
}

// 📤 Export
export { fetchNextPage, updateUrlPath, updatePaginationNav, renderData };
